import jwt_decode from "jwt-decode";

export const GetUserRole = () => {
    var token = localStorage.getItem('accessToken');
    if (token !== null) {
        var user = jwt_decode(token);
        return user.roleId
    } else {
        return 0
    }
}
export function CanView(props) {
    var token = localStorage.getItem('accessToken');
    if (token !== null) {
        var user = jwt_decode(token);
        if (user.roleId === props.role) {
            return props.children
        } else {
            return null
        }
    } else {
        return null
    }
}